import {Pipe, PipeTransform} from '@angular/core';
import {Country, Waypoint} from "@model";

@Pipe({
    name: 'waypointLocation',
    standalone: false
})
export class WaypointLocationPipe implements PipeTransform {

  transform(waypoint: Waypoint | undefined, countries: Country[]|undefined): string | undefined {
    return this.getWaypointLocation(waypoint, countries);
  }

  getWaypointLocation(waypoint: Waypoint | undefined, countries: Country[]|undefined): string {
    let location: string = "";
    if (waypoint?.city && waypoint?.city !== "") {
      location = waypoint!.city;
    } if (waypoint?.address && waypoint?.address !== "") {
      location = location + ", " + waypoint?.address;
    } if (waypoint?.additionalMark && waypoint?.additionalMark !== "") {
      location = location + ", " + waypoint?.additionalMark;
    } if (waypoint?.country && waypoint.country !== 0 && countries && countries.length > 0) {
      let country: Country|undefined = countries.find((item:Country)=>item.id === waypoint.country);
      if (country) {
        location = location + ", " + country.name;
      }
    }
    if (location === "") {
      location = "-"
    }
    return location;
  }
}
